import React from 'react';

const Cliente = React.createContext();

export default Cliente;
